export interface NavLink {
  id: string;
  label: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { id: 'nav-top', label: '首页', href: '#top' },
  { id: 'nav-entries', label: '最新入口', href: '#entries' },
  { id: 'nav-ranking', label: '热度榜单', href: '#ranking' },
  { id: 'nav-feed', label: '爆料速览', href: '#feed' },
  { id: 'nav-mirrors', label: '镜像汇总', href: '#mirrors' },
  { id: 'nav-guide', label: '防走丢', href: '#guide' },
  { id: 'nav-faq', label: '常见问题', href: '#faq' },
];

export const hotSearches: string[] = [
  '黑料网站入口',
  '最新备用地址',
  '镜像节点',
  '防走丢合集',
  '今日可用线路',
];

export interface HeroStat {
  id: string;
  label: string;
  value: string;
  unit: string;
}

export const heroStats: HeroStat[] = [
  { id: 'stat-entries', label: '收录入口', value: '128', unit: '条' },
  { id: 'stat-online', label: '在线线路', value: '42', unit: '条' },
  { id: 'stat-today', label: '今日更新', value: '12', unit: '条' },
  { id: 'stat-speed', label: '平均响应', value: '68', unit: 'ms' },
];

export const entryTabs: string[] = ['全部', '官网入口', '备用线路', '镜像节点'];

export interface EntryItem {
  id: string;
  name: string;
  type: string;
  state: string;
  region: string;
  response: string;
  updated: string;
  addr: string;
}

export const entryItems: EntryItem[] = [
  {
    id: 'entry-a',
    name: '主站入口 · 线路 A',
    type: '官网入口',
    state: '可用',
    region: '华东',
    response: '38ms',
    updated: '3 分钟前',
    addr: 'entry-a.hl-entry.top',
  },
  {
    id: 'entry-b',
    name: '主站入口 · 线路 B',
    type: '官网入口',
    state: '可用',
    region: '华北',
    response: '45ms',
    updated: '8 分钟前',
    addr: 'entry-b.hl-entry.top',
  },
  {
    id: 'entry-c',
    name: '备用线路 · 线路 C',
    type: '备用线路',
    state: '可用',
    region: '华南',
    response: '62ms',
    updated: '12 分钟前',
    addr: 'backup-c.hl-entry.top',
  },
  {
    id: 'entry-d',
    name: '备用线路 · 线路 D',
    type: '备用线路',
    state: '限速',
    region: '西南',
    response: '71ms',
    updated: '20 分钟前',
    addr: 'backup-d.hl-entry.top',
  },
  {
    id: 'entry-hk',
    name: '镜像节点 · HK-01',
    type: '镜像节点',
    state: '可用',
    region: '香港',
    response: '88ms',
    updated: '25 分钟前',
    addr: 'mirror-hk.hl-node.top',
  },
  {
    id: 'entry-sg',
    name: '镜像节点 · SG-02',
    type: '镜像节点',
    state: '可用',
    region: '新加坡',
    response: '96ms',
    updated: '31 分钟前',
    addr: 'mirror-sg.hl-node.top',
  },
  {
    id: 'entry-jp',
    name: '镜像节点 · JP-03',
    type: '镜像节点',
    state: '检测中',
    region: '日本',
    response: '112ms',
    updated: '40 分钟前',
    addr: 'mirror-jp.hl-node.top',
  },
  {
    id: 'entry-e',
    name: '隐藏入口 · 线路 E',
    type: '官网入口',
    state: '可用',
    region: '海外',
    response: '118ms',
    updated: '55 分钟前',
    addr: 'hidden-e.hl-entry.top',
  },
];

export interface RankItem {
  id: string;
  rank: number;
  topic: string;
  heat: string;
  trend: 'up' | 'flat' | 'down';
  tag: string;
}

export const rankItems: RankItem[] = [
  { id: 'rank-1', rank: 1, topic: '新一季综艺阵容路透整理', heat: '98.6', trend: 'up', tag: '置顶' },
  { id: 'rank-2', rank: 2, topic: '都市情感剧收官讨论汇总', heat: '96.2', trend: 'flat', tag: '推荐' },
  { id: 'rank-3', rank: 3, topic: '音乐节现场回放合集热度', heat: '94.8', trend: 'up', tag: '推荐' },
  { id: 'rank-4', rank: 4, topic: '短剧联动企划细节曝光', heat: '92.1', trend: 'up', tag: '热' },
  { id: 'rank-5', rank: 5, topic: '纪录片新作定档预告', heat: '89.5', trend: 'flat', tag: '热' },
  { id: 'rank-6', rank: 6, topic: '品牌发布会现场图讨论', heat: '87.3', trend: 'up', tag: '新' },
  { id: 'rank-7', rank: 7, topic: '海外剧集引进名单更新', heat: '85.6', trend: 'down', tag: '新' },
  { id: 'rank-8', rank: 8, topic: '年度盘点投票实时实况', heat: '83.2', trend: 'flat', tag: '新' },
];

export interface NewsItem {
  id: string;
  size: 'feature' | 'image' | 'text';
  title: string;
  excerpt: string;
  category: string;
  time: string;
  reads: string;
  image: string;
}

export const newsItems: NewsItem[] = [
  {
    id: 'news-1',
    size: 'feature',
    title: '综艺新一季阵容首次同框，录制现场细节整理',
    excerpt:
      '多组路透画面与现场细节一并收录，配合节目组释出的定档信息，快速了解本季看点分布在哪里。',
    category: '综艺',
    time: '2 小时前',
    reads: '1.2 万',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20illustration%20of%20an%20entertainment%20studio%20set%2C%20abstract%20geometric%20camera%20and%20spotlight%20shapes%2C%20crimson%20and%20amber%20palette%20on%20a%20soft%20cream%20background%2C%20clean%20minimalist%20composition%2C%20subtle%20film%20grain%20texture%2C%20high%20detail%2C%20restrained%20modern%20aesthetic&width=900&height=620&seq=hailiao-news-01&orientation=landscape',
  },
  {
    id: 'news-2',
    size: 'image',
    title: '音乐节现场回放全平台上线，多版本画质可选',
    excerpt: '回放资源按舞台分区整理，附带完整曲目时间轴，方便按需定位观看。',
    category: '音乐',
    time: '3 小时前',
    reads: '8,640',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20illustration%20of%20a%20music%20festival%20stage%20at%20dusk%2C%20abstract%20geometric%20silhouettes%20of%20speakers%20and%20lights%2C%20deep%20crimson%20and%20golden%20amber%20palette%20on%20cream%20background%2C%20clean%20minimalist%20composition%2C%20subtle%20grain%20texture%2C%20high%20detail%2C%20restrained%20modern%20aesthetic&width=800&height=620&seq=hailiao-news-02&orientation=landscape',
  },
  {
    id: 'news-3',
    size: 'text',
    title: '都市情感剧收官数据出炉，长尾讨论仍在走高',
    excerpt: '收官周播放与讨论数据同步刷新，热门片段与观众反馈分类收录。',
    category: '剧集',
    time: '4 小时前',
    reads: '6,210',
    image: '',
  },
  {
    id: 'news-4',
    size: 'text',
    title: '短剧达人跨界联动企划曝光，预约通道同步开启',
    excerpt: '联名企划的分集排期与预约入口已整理成表，更新节奏一目了然。',
    category: '短剧',
    time: '5 小时前',
    reads: '5,780',
    image: '',
  },
  {
    id: 'news-5',
    size: 'text',
    title: '品牌发布会现场图流出，代言传闻持续发酵',
    excerpt: '现场流程与释出物料按时间线梳理，相关传闻暂未得到官方回应。',
    category: '商务',
    time: '6 小时前',
    reads: '4,930',
    image: '',
  },
  {
    id: 'news-6',
    size: 'image',
    title: '纪录片新作正式定档，题材聚焦城市夜生活',
    excerpt: '首支预告与主创访谈同步释出，取景地清单随片方物料一并整理。',
    category: '纪实',
    time: '8 小时前',
    reads: '3,860',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20illustration%20of%20a%20city%20night%20skyline%20in%20flat%20geometric%20layers%2C%20glowing%20windows%20and%20street%20lights%2C%20crimson%20and%20amber%20accents%20on%20a%20cream%20background%2C%20clean%20minimalist%20poster%20composition%2C%20subtle%20grain%20texture%2C%20high%20detail%2C%20restrained%20modern%20aesthetic&width=800&height=620&seq=hailiao-news-03&orientation=landscape',
  },
  {
    id: 'news-7',
    size: 'feature',
    title: '年度盘点投票开启，多组实时榜单同步刷新',
    excerpt:
      '投票通道与实时名次面板同时上线，榜单每十分钟刷新一次，历史快照也可以回看对比。',
    category: '榜单',
    time: '昨天',
    reads: '1.5 万',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20illustration%20of%20abstract%20ranking%20charts%20and%20data%20bars%2C%20floating%20geometric%20panels%20with%20numbers%2C%20crimson%20and%20amber%20palette%20on%20cream%20background%2C%20clean%20minimalist%20composition%2C%20subtle%20paper%20grain%2C%20high%20detail%2C%20restrained%20modern%20aesthetic&width=900&height=620&seq=hailiao-news-04&orientation=landscape',
  },
];

export interface MirrorItem {
  id: string;
  node: string;
  region: string;
  type: string;
  status: string;
  uptime: string;
  load: number;
}

export const mirrorItems: MirrorItem[] = [
  { id: 'mirror-hk', node: 'HK-01', region: '香港', type: '镜像节点', status: '在线', uptime: '99.9%', load: 42 },
  { id: 'mirror-sg', node: 'SG-02', region: '新加坡', type: '镜像节点', status: '在线', uptime: '99.8%', load: 38 },
  { id: 'mirror-jp', node: 'JP-03', region: '日本', type: '镜像节点', status: '维护', uptime: '97.2%', load: 61 },
  { id: 'mirror-us', node: 'US-04', region: '美国', type: '备用线路', status: '在线', uptime: '99.5%', load: 55 },
  { id: 'mirror-de', node: 'DE-05', region: '德国', type: '备用线路', status: '在线', uptime: '99.4%', load: 47 },
  { id: 'mirror-tw', node: 'TW-06', region: '台湾', type: '镜像节点', status: '在线', uptime: '99.7%', load: 44 },
];

export interface GuideStep {
  id: string;
  step: string;
  title: string;
  desc: string;
}

export const guideSteps: GuideStep[] = [
  {
    id: 'guide-1',
    step: '01',
    title: '先收藏本页',
    desc: '把当前地址加入浏览器书签，即便域名更换也能从历史记录里找回这个汇总页。',
  },
  {
    id: 'guide-2',
    step: '02',
    title: '记住备用线路',
    desc: '主入口不可用时，优先在最新入口区域切换备用线路，通常能直接恢复访问。',
  },
  {
    id: 'guide-3',
    step: '03',
    title: '打不开就刷新',
    desc: '页面会持续巡检并更新可用地址，遇到打不开先刷新本页，再看是否出现新节点。',
  },
  {
    id: 'guide-4',
    step: '04',
    title: '多存一份备份',
    desc: '顺手把地址记进笔记或聊天收藏，多处留档，基本就不会出现找不到新网址的情况。',
  },
];

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    q: '为什么入口地址会经常更换？',
    a: '线路会根据网络环境与访问情况做调整，域名与节点也会不定期更新，因此建议收藏本页，随时回来查看最新地址。',
  },
  {
    id: 'faq-2',
    q: '打不开时应该先做什么？',
    a: '先刷新本页确认是否已经更新了新地址，再依次尝试备用线路与镜像节点，多数情况下切换节点即可恢复正常访问。',
  },
  {
    id: 'faq-3',
    q: '备用线路和镜像节点有什么区别？',
    a: '备用线路是同一站点的冗余通道，镜像节点则是部署在不同地区的同源站点，两者都能在主入口不可用时作为替代入口。',
  },
  {
    id: 'faq-4',
    q: '怎样避免找不到新网址？',
    a: '收藏本页并开启浏览器账号同步，同时记录两到三个备用地址，形成多重备份后基本就不会再走丢。',
  },
  {
    id: 'faq-5',
    q: '页面上的地址多久更新一次？',
    a: '常规情况下每天多次巡检，遇到线路调整会第一时间在最新入口区域标注更新时间，方便对照查看。',
  },
  {
    id: 'faq-6',
    q: '手机端可以正常访问吗？',
    a: '可以。本页与入口均适配移动端，建议用手机浏览器打开后添加到主屏幕，随时点开就能查看最新地址。',
  },
];

export interface FooterGroup {
  id: string;
  title: string;
  links: NavLink[];
}

export const footerGroups: FooterGroup[] = [
  {
    id: 'footer-nav',
    title: '站内导航',
    links: [
      { id: 'f-top', label: '首页概览', href: '#top' },
      { id: 'f-entries', label: '最新入口', href: '#entries' },
      { id: 'f-ranking', label: '热度榜单', href: '#ranking' },
      { id: 'f-feed', label: '爆料速览', href: '#feed' },
    ],
  },
  {
    id: 'footer-entry',
    title: '入口相关',
    links: [
      { id: 'f-mirrors', label: '镜像汇总', href: '#mirrors' },
      { id: 'f-guide', label: '防走丢指南', href: '#guide' },
      { id: 'f-faq', label: '常见问题', href: '#faq' },
      { id: 'f-status', label: '线路状态', href: '#mirrors' },
    ],
  },
  {
    id: 'footer-help',
    title: '帮助与说明',
    links: [
      { id: 'f-how', label: '如何收藏本页', href: '#guide' },
      { id: 'f-report', label: '反馈失效入口', href: '#faq' },
      { id: 'f-notice', label: '浏览须知', href: '#faq' },
      { id: 'f-about', label: '关于本站', href: '#top' },
    ],
  },
];

export const categoryChips: string[] = ['全部', '综艺', '剧集', '音乐', '短剧', '纪实', '商务', '榜单'];